import { Component, inject } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'ciphr-unsaved-changes',
  standalone: true,
  imports: [TranslocoDirective, ChrComponentsModule],
  templateUrl: './unsaved-changes.component.html',
  styleUrls: ['./unsaved-changes.component.scss'],
})
export class UnsavedChangesComponent {
  readonly dialogData = inject<{ title: string }>(DIALOG_DATA);
  private readonly dialogRef = inject(DialogRef);

  closeModal(): void {
    this.dialogRef.close(true);
  }

  returnToPage(): void {
    this.dialogRef.close(false);
  }
}
